<template>
	<div class="o-wrap">
		<el-page-header @back="$router.go(-1)" content="编辑参展公司" />
		<NewForm :newsForm="form" @eventForm="handleGetForm" />
	</div>
</template>

<script>
	import NewForm from '@/components/Zhgl/Form'
	export default {
		data() {
			return {
				form: {},
				exhibition_id:'',
				shop_id:''
			}
		},
		created() {
			this.exhibition_id = this.$route.query.id
			this.shop_id = this.$route.query.shopid
			this.$axios.post('Exhibition-Admin-getExhibitionCompanyInfo', {
				user_id:this.$store.state.USER_ID,
				shop_id:this.shop_id ,
				exhibition_id:this.exhibition_id,
			}).then(data => {
				this.form = data
			})
		},
		methods: {
			handleGetForm(form) {
				this.$axios.post('Exhibition-Admin-addSaveExhibitionCompanyInfo', form).then(data => {
					this.$message.success('修改成功')
					// this.$router.push(`/player?id=${id}`)
				})
			}
		},
		components: {
			NewForm
		}
	}
</script>

<style>
</style>
